import { Context } from '@sentry/angular';
import { getTokenParams } from './get-token-params';

interface ClientContext extends Context {
  userAgent: string;
  browserLanguage: string;
  platform: string;
  referrer: string;
  instance: string;
  gameUuid: string;
  isFromHub: boolean;
  hubGameUuid: string;
  gameLanguage: string;
  backgroundColor: string;
}

export function getClientContext(): ClientContext {
  const { instance, gameUuid, isFromHub, hubGameUuid, language, bg } =
    getTokenParams();

  return {
    userAgent: navigator.userAgent,
    browserLanguage: navigator.language,
    platform: navigator.platform,
    referrer: document.referrer,
    instance,
    gameUuid,
    isFromHub,
    hubGameUuid,
    gameLanguage: language,
    backgroundColor: bg,
  };
}
